// extracted by mini-css-extract-plugin
export const backgroundContainer = "not-found-module--background-container--3X--O";